import React from "react";

export const HTMLHiddenChar: React.FC = () => {
  return (
    <span id="hide-on-drag" data-disable-blur-event>
      &zwnj;
    </span>
  );
};
